// Lib
import React, { ReactElement } from 'react';

// Components
import Spinner from '../../../../../../../components/loaders/Spinner';
import AiButton from '../components/AiButton';

// Styles
import './AiAssistantPromptStreaming.scss';

interface AiAssistantPromptLoadingProps {
    handleCancelClick: () => void;
}

const AiAssistantPromptStreaming = ({ handleCancelClick }: AiAssistantPromptLoadingProps): ReactElement => {
    return (
        <div className="AiAssistantPromptStreaming">
            <Spinner show />

            <div className="text-container-wrapper">
                <div className="text-container">
                    <span>Working on it...</span>
                </div>
            </div>

            <AiButton className="cancel-button ghost" onClick={handleCancelClick}>
                Cancel
            </AiButton>
        </div>
    );
};

export default AiAssistantPromptStreaming;
